export default "__VITE_ASSET__wcA3ajNu__"